import axios from 'axios';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend, { ChainedBackendOptions } from "i18next-chained-backend";
import HttpApi from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { Axios } from '../api/axios';
import translationEN from './en.json'
import i18next, { createInstance } from 'i18next';
import { logger } from '../utils/logger';

export const resources = {
    en: {
      translation: translationEN,
    },
  }

  const options = {
    order: ["path"],
    // caches: ['localStorage'],
    backends: [resourcesToBackend(resources), HttpApi],
    backendOptions: [
      {
        // 로컬 리소스 백엔드 (첫 번째)
        // 별도 옵션 없음 - 기본 동작
      },
      {
        // loadPath: function(lng,ns) {
          // let path = ""
          // if(ns[0] === 'translation') {
          //   path = `./locales/${lng}.json`
          // } else {
          //   path =  `${REMOTE_LNG}${ns}/translation.${ns}.json`
          // }
          // logger.log('loadpath',lng,ns,path)
          // return path;
        // },
        // loadPath: "{{ns}}",
        
        // 로컬 리소스에서 로드해야 하는지 확인하는 헬퍼 함수
        shouldUseLocalResources: function(ns: string | number | null | undefined): boolean {
          return ns === undefined || ns === null || ns === 'translation' || ns === 0 || 
                 (typeof ns === 'string' && (ns.includes('translation') || ns === ''));
        },
        
        loadPath: function(lng: any, ns: string | number | null | undefined) {
          logger.log('ns', ns)
          // translation 관련 namespace는 로컬 리소스에서 로드하도록 null 반환
          if (this.shouldUseLocalResources(ns)) {
            logger.log('Using local resources for namespace:', ns);
            return null;
          } else {
            return ns;
          }
        },
        request: function (options: any, url: any, payload: any, callback: (arg0: null, arg1: { status: number; data: any; }) => void) {
          logger.log('request called with:', options, url)
          
          // 더 강력한 필터링: translation 관련 모든 URL 차단
          if(this.shouldUseLocalResources(url) || 
             (typeof url === 'string' && url.toLowerCase().includes('translation')) ||
             url === 'translation' || url === 'Translation' || url === 'TRANSLATION') {
            logger.log('Blocking API call for translation-related URL:', url);
            // translation 관련 요청은 즉시 성공으로 처리하여 다음 백엔드로 넘어가지 않도록 함
            callback(null, { status: 200, data: {} });
            return;
          }
          
          Axios(
            { 
              method: 'get',
              url: `/i18n/stores/${url}`
      
            }).then((res) => {
              callback(null, { status: 200, data: res.data });
          }).catch((err) => {
            logger.log('API call failed for:', url, err);
            // API 호출 실패 시에도 callback을 호출하여 i18next가 계속 작동하도록 함
            callback(null, { status: 404, data: {} });
          });
        },
        ajax: axios,
        crossDomain: true,
        overrideMimeType: false,
        allowMultiLoading: true,
        cacheHitMode: 'refreshAndUpdateStore',
        reloadInterval: 360 * 60 * 1000,
        refreshExpirationTime: 7 * 24 * 60 * 60 * 1000,
        getAsync: false, 
        withCredentials: false,
        reloadOnPrerender: true,
        serializeConfig: false,
        // translation 관련 요청을 완전히 차단
        allowLoad: function(lng: string, ns: string) {
          if (ns === 'translation' || ns.includes('translation')) {
            logger.log('Blocking load for translation namespace:', ns);
            return false;
          }
          return true;
        }
        // returnObject: true,
        // returnEmptyString: true,
        // retureNull: true,
  //       loadPath: 'https://translation.rightwayhealthcare.com/en.json'
      },
    ],
  }
  export const initOptions = {
    compatibilityJSON: 'v3',
    // jsonFormat: 'v4',
    ns: [],
    defaultNS: [],
  //   resources,
    // nonExplicitSupportedLngs: true,
    lng: 'en',
    fallbackLng: 'en',
    // supportedLngs: ['en', 'ko', 'es', 'zh'],
    // fallbackNS: 'translation',
    keySeparator: '.',
    nsSeparator: ':',
    contextSeparator: '-',
    interpolation: {
      escapeValue: false,
    },
    load: 'currentOnly',
    react: {
     bindI18n: 'loaded init',
     useSuspense: true,
    //  bindI18n: 'languageChanged loaded',
    },
    backend: options,
  //   ns: ,
    // saveMissing: true,
    partialBundledLanguages: true,
    debug: false
  }
  
  const i18n = createInstance()
  export const coreInit = (option: any) => {
    i18n.use(ChainedBackend).use(LanguageDetector).use(initReactI18next).init<ChainedBackendOptions>(option
      , (err) => {
        if (err) {
          logger.error('i18n initialization error:', err);
        } else {
          logger.log('i18n initialized successfully');
        }
      }
    )
   }

  // i18next.addResourceBundle('en', '1', translationEN);
  
  export function changeLng(lng: string | undefined) {
    logger.log("lng",lng)
    i18next.changeLanguage(lng);
  }
  
  export function loadNamespace(ns: string | readonly string[]) {
    logger.log("ns",ns)
    i18next.loadNamespaces(ns, (err: any, t: any) => { logger.log(err) });
  }
  
  export default i18n
